// shareUtils.js

export function shareContent() {
    if (navigator.share) {
      const shareData = {
        title: 'Studio',
        text: 'Sign up to workout with me!',
        url: 'https://studio3-referral.vercel.app/', // Replace with the URL you want to share
      };
  
      return navigator.share(shareData)
        .then(() => {
          console.log('Successfully shared.');
        })
        .catch((error) => {
          console.error('Error sharing:', error);
        });
    } else {
      console.log('Web Share API is not supported in this browser.');
      return Promise.reject('Web Share API not supported');
    }
  }
  